import React from 'react';
import { ImageIcon, MessageSquareIcon, CodeIcon, PencilIcon, MusicIcon, VideoIcon, SparklesIcon, LightbulbIcon, ChefHatIcon } from 'lucide-react';
export const getIcon = (iconName: string) => {
  const iconMap: {
    [key: string]: React.ReactNode;
  } = {
    image: <ImageIcon className="h-6 w-6 text-white" data-id="element-2482" />,
    'message-square': <MessageSquareIcon className="h-6 w-6 text-white" data-id="element-2483" />,
    code: <CodeIcon className="h-6 w-6 text-white" data-id="element-2484" />,
    pencil: <PencilIcon className="h-6 w-6 text-white" data-id="element-2485" />,
    music: <MusicIcon className="h-6 w-6 text-white" data-id="element-2486" />,
    video: <VideoIcon className="h-6 w-6 text-white" data-id="element-2487" />,
    sparkles: <SparklesIcon className="h-6 w-6 text-white" data-id="element-2488" />,
    lightbulb: <LightbulbIcon className="h-6 w-6 text-white" data-id="element-2489" />,
    'chef-hat': <ChefHatIcon className="h-6 w-6 text-white" data-id="element-2490" />
  };
  return iconMap[iconName] || <ImageIcon className="h-6 w-6 text-white" data-id="element-2491" />;
};